export { ZipService } from './zip.service';
export { AdZipModule } from './zip.module';
export * from './interface';
